import { v4 as uuidv4 } from 'uuid';
import { Ajax2 } from '@shared/Ajax';

export enum TelemetryEventType {
    // https://infrakit.atlassian.net/wiki/spaces/ERD/pages/51511347/Infrakit+OFFICE+Map+Functions

    MAP_DRAG_MOUSE = 'O2WMB', // Map viewport, hold any mouse button, move pointer
    MAP_ZOOM_WHEEL_SCALE = 'O2WZS', // Map viewport, mouse wheel, or the scale slider
    MAP_MODELS_TREE_CHECK = 'O2OI', // Sidebar Models panel folder tree with checkbox for each item
    MAP_ASBUILT_TREE_CHECK = 'O2BTI', // Sidebar As-built panel Tree folder tree with checkbox for each item

    MAP_ZOOM_NUMERIC = 'O2WZN', // Map viewport, Map scale numeric input field
    MAP_CLICK_DOC = 'O2WLD', // Map viewport, left mouse button click over document icon
    MAP_CLICK_RIGHT = 'O2WRN', // Map viewport, right mouse button click (anywhere)
    MAP_CLICK_RIGHT_MODEL = 'O2WRO', // Map viewport, right mouse button click over model
    MAP_DOC_POPUP_VIEW = 'O2WDV', // Document popup dialog
    MAP_DOC_POPUP_DOWNLOAD = 'O2WDCD', // Document popup controls Download button
    MAP_DOCS_FIT_VIEW = 'O2DFF', // Sidebar Documents panel Fit visible into view button
    MAP_DOCS_FILTER_PERIOD = 'O2DFQ', // Sidebar Documents panel Filter time period buttons
    MAP_MODELS_SELECT_ALL = 'O2OA', // Sidebar Models panel Select All button
    MAP_ASBUILT_DOWNLOAD = 'O2BD', // Sidebar As-built panel Download logpoints button (enabled when at least one logpoint folder or file is selected in the tree)
    MAP_ASBUILT_FIT_VIEW = 'O2BFF', // Sidebar As-built panel Fit visible into view button
    MAP_ASBUILT_FILTER_PERIOD = 'O2BFP', // Sidebar As-built panel Filter From and To date selectors
    MAP_EQUIPMENT_FIT_VIEW = 'O2EFF', // Sidebar Equipment panel Fit visible into view button
    MAP_EQUIPMENT_SHOW_VEHICLES = 'O2EM', // Sidebar Equipment panel, Show vehicles on map checkbox
    MAP_IMAGES_BULK_EDIT = 'O2IBE', // Sidebar Images panel Bulk edit images dialog (after choosing images to edit)
    MAP_IMAGES_FILTER_PERIOD = 'O2IFQ', // Sidebar Images panel Filter time period buttons
    MAP_IMAGES_FILTER_NAME = 'O2IFN', // Sidebar Images panel Filter Name/Description text box
    MAP_IMAGES_FIT_VIEW = 'O2IFF', // Sidebar Images panel Fit visible into view button
    SAVED_VIEWS_CREATE = 'O2SA', // Sidebar Saved views panel Save view button
    SAVED_VIEWS_EDIT = 'O2SE', // Sidebar Saved views Edit dialog with Name text box, Folder selector, Visibility selector, and Save button
    SAVED_VIEWS_SHARE = 'O2SLMS', // Sidebar Saved views panel thumbnails list Thumbnail menu option Share
    MAP_2D_TOOLBAR_FREE_CS = 'O2TFC', // Toolbar Draw free cross section button
    MAP_2D_TOOLBAR_FIT = 'O2TF', // Toolbar Fit visible button
    MAP_2D_TOOLBAR_3D_VIEW = 'O2T3', // Toolbar 3D view button
}

export enum TelemetrySource {
    MAP_2D_DESKTOP = 'office-map-2d-desktop',
    MAP_2D_TABLET = 'office-map-2d-tablet',
}

interface TelemetryEvent {
    useCaseId: TelemetryEventType;
    uuid: string;
    unixtimeMillis: number;
    source: string;
    idp: string;
    user: string;
    identifier: string;
    org: string;
    project: string;
    userAgent: string;
    params: string;
    status: string;
}

const THROTTLE_THRESHOLD = 1000;
const lastCallForType: Record<TelemetryEventType, number> = {} as any;

function add(type: TelemetryEventType, source: TelemetrySource, params?: string) {
    if (window.location.href.includes('localhost') || window.location.href.includes('192.168')) {
        return;
    }

    const now = new Date().getTime();
    const lastCall = lastCallForType[type] || 0;
    if (now - lastCall < THROTTLE_THRESHOLD) {
        return;
    }
    lastCallForType[type] = now;

    const event: TelemetryEvent = {
        uuid: uuidv4(),
        unixtimeMillis: now,
        source,
        idp: 'IDP: Infrakit office',
        user: kuura.getUserUuid(),
        org: kuura.getProjectOrganization().uuid,
        project: kuura.getProjectUuid(),
        identifier: type.toString(),
        userAgent: navigator.userAgent,
        useCaseId: type,
        params,
        status: '',
    };

    const root = kuura.AwsApiGatewayDomain() + '/telemetry';

    return Ajax2({
        url: root + '/user/event',
        method: 'POST',
        data: event,
        contentType: 'json',
        useToken: true,
    });
}

export const Telemetry = {
    add: (type: TelemetryEventType, source: TelemetrySource, params?: string) => {
        setTimeout(() => {
            add(type, source, params);
        }, 1000);
    },
};
